import type { QueryClient } from "@tanstack/react-query";

/**
 * Marks everything derived from a workspace's people, configurations and usage as stale.
 * Each feature keeps its keys under ["<feature>", workspaceId, ...] so one prefix covers it.
 */
export function invalidateWorkspaceData(queryClient: QueryClient, workspaceId: string) {
  const prefixes = ["persons", "configurations", "changes", "slots", "usage"] as const;
  return Promise.all(
    prefixes.map((prefix) => queryClient.invalidateQueries({ queryKey: [prefix, workspaceId] })),
  ).then(() => undefined);
}
